<div [class.is-personalized-layout]="!!layoutVars">
  <div class="card card-offer-evaluation mb-3">
    <div class="card-body">
      <!-- HEADER -->
      @if (fipePrice > 0 || revisionEstimated() > 0 || molicarPrice() > 0) {
      <div class="mb-4">
        @if (fipePrice > 0) {
        <div class="row lines-info" (click)="animationState = animationState === 'in' ? 'out' : 'in' ">
          <div class="col-md-6 label">
            <i class="material-icons">list</i>
            <span>TABELA FIPE</span>
          </div>
          <div class="col-md-6 label-description" matTooltip="Histórico FIPE">R$ {{fipePrice | number: '1.2-2'}}</div>
          <i class="material-icons animate" matTooltip="Histórico FIPE"
            [ngClass]="{'open': animationState == 'in'}">expand_more</i>

          <div class="item-body" [@slideInOut]="animationState">
            <div class="row detail">
              <span class="label pl-1 my-2">Histórico dos últimos 6 meses.</span>
              <app-dash-fipe [oldFipes]="vehicle().oldFipePrices" [currentFipe]="vehicle().fipePrice ?? 0"
                [futureFipe]="vehicle().futureFipePrice ?? 0" [evaluation]="true"></app-dash-fipe>
            </div>
          </div>
        </div>
        }
        <!-- @if (molicarPrice() > 0) {
        <div class="row lines-info mt-3 c-pointer" (click)="clickDetailMolicar.emit()">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <span class="d-block text-right text-info-value">a partir de</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 label">
                <i class="material-icons">attach_money</i>
                <span>PREÇO MOLICAR</span>
              </div>
              <div class="col-md-6 label-description c-pointer">
                R$ {{molicarPrice() | number: '1.2-2'}}
              </div>
            </div>
          </div>
        </div>
        } -->
        @if (vehicle().minSellPrice && isManager()) {
        <div class="row lines-info mt-3">
          <div class="col-md-6 label">
            <i class="material-icons">attach_money</i>
            <span>PREÇO MÍNIMO P/ VENDA</span>
          </div>
          <div class="col-md-6 label-description">R$ {{vehicle().minSellPrice | number: '1.2-2'}}</div>
        </div>
        }
        @if (vehicle().listPrice && isManager()) {
        <div class="row lines-info mt-3">
          <div class="col-md-6 label">
            <i class="material-icons">attach_money</i>
            <span>PREÇO MÍNIMO P/ ANÚNCIO</span>
          </div>
          <div class="col-md-6 label-description">R$ {{vehicle().listPrice | number: '1.2-2'}}</div>
        </div>
        }
        @if (revisionEstimated() > 0) {
        <div class="row lines-info mt-3">
          <div class="col-md-6 label ">
            <i class="material-icons">settings</i>
            <span>REVISÃO ESTIMADA</span>
          </div>
          <div class="col-md-6 label-description">
            R$ {{revisionEstimated() | number: '1.2-2'}}
          </div>
        </div>
        }
        @if (vehicle().finalEvalScore) {
        <div class="row lines-info mt-3">
          <div class="col-md-6 label ">
            <i class="material-icons">show_chart</i>
            <span>CLASSIFICAÇÃO</span>
          </div>
          <div class="col-md-6 label-description d-flex justify-content-end gap-1">
            {{ vehicle().useEvalScoreABC ? vehicle().finalEvalScoreABC : (vehicle().finalEvalScore | number) }}
            @if (isOKFinalScore()) {
            <i class="material-icons ok-icon" style="position: relative; top: 1px;">check_circle</i>
            }
            @if (isWarningFinalScore()) {
            <i class="material-icons warning-icon" style="position: relative; top: 1px;">warning</i>
            }
            @if (isDangerFinalScore()) {
            <i class="material-icons danger-icon" style="position: relative; top: 1px;">error</i>
            }
          </div>
        </div>
        }
      </div>
      }
      <!--/ HEADER -->

      @if (!showGiveBack) {
      <!-- BOX-INFO -->
      @if (!showBoxEditPrice) {
      <div class="row box-input">
        @if (canSeePrices()) {
        <div class="col-md-12 value">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h3>
              <i class="app-icon-tag"></i>{{ vehicle().status !== 'AWAITING_ENTRY' ? (vehicle().estimatedPrice ? 'PREÇO ESTIMADO' : 'PREÇO PARA COMPRA') : 'VALOR ACEITO' }}
            </h3>
            @if (fipePrice > 0) {
            <app-fipe-comparison-badge
              variant="tag"
              accentColor="#16B097"
              [price]="finalPurchasePrice()"
              [fipePrice]="fipePrice"
              [displayMode]="userInfo?.fipeComparisonMode"
              digits="1.1-1"
            />
            }
          </div>
          <div class="col-md-12 mt-2">
            <span class="symbol">R$</span>
            <span class="value">{{ finalPurchasePrice() | number: '1.2-2' }}</span>
          </div>
          @if (vehicle().status === 'AWAITING_ENTRY' && vehicle().negotiationClosedAt) {
          <div class="col-md-12">
            <span class="label" style="font-size: 14px;">Aceito em: {{ vehicle().negotiationClosedAt | date:
              'dd/MM/yyyy' }}</span>
          </div>
          }
          @if (hasPriceComposition()) {
          <div class="col-md-12 mt-3 px-0">
            <div class="composition-section">
              <div class="composition-header">
                <i class="material-icons">info</i>
                <span>COMPOSIÇÃO DO VALOR</span>
              </div>

              <div class="composition-items">
                <div class="composition-item">
                  <span class="composition-label">Valor de paga</span>
                  <span class="composition-value">R$ {{ vehicle().price | number: '1.2-2' }}</span>
                </div>
                @if ((vehicle().factoryBonus ?? 0) > 0) {
                <div class="composition-item">
                  <span class="composition-label">Bônus de fábrica</span>
                  <span class="composition-value bonus">+ R$ {{ vehicle().factoryBonus | number: '1.2-2' }}</span>
                </div>
                }
                @if ((vehicle().interventionPrice ?? 0) > 0) {
                <div class="composition-item">
                  <span class="composition-label">Intervenção</span>
                  <span class="composition-value bonus">+ R$ {{ vehicle().interventionPrice | number: '1.2-2' }}</span>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
        }
        <div class="col-md-12">
          @if (vehicle().status === 'NEGOTIATION' && hasPermissionAddStatusNegotiation()) {
          <div class="status-negotiation" [attr.data-status]="vehicle().negotiationStatus">
            <div (click)="openModalStatus()">
              @if (!vehicle().negotiationStatus) {
              <div class="add-status-negotiation-wrapper">
                <div class="add-status-negotiation">
                  Incluir status da negociação
                </div>
                @if (showStatusNegotiationTooltip()) {
                  <app-small-feature-announcement
                    badgeText="DEU NEGÓCIO?"
                    description="Como está o andamento dessa negociação? Registre o status."
                    positionMode="anchor"
                    placement="right"
                    [showCloseButton]="true"
                  />
                }
              </div>
              }

              @if (vehicle().negotiationStatus === 'HOT') {
              <div class="row" style="cursor: pointer;">
                <div class="col-2">
                  <i class="fa-solid fa-temperature-hot icon-label"></i>
                </div>
                <div class="col-9">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">QUENTE</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'TEPID') {
              <div class="row" style="cursor: pointer;">
                <div class="col-2">
                  <i class="fa-solid fa-temperature-low icon-label"></i>
                </div>
                <div class="col-9">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">MORNO</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'COLD') {
              <div class="row" style="cursor: pointer;">
                <div class="col-2">
                  <i class="fa-solid fa-temperature-frigid icon-label"></i>
                </div>
                <div class="col-9">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">FRIO</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'DEAL_DONE') {
              <div class="row" style="cursor: pointer;">
                <div class="col-2">
                  <i class="fa-solid fa-handshake icon-label"></i>
                </div>
                <div class="col-9">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">DEU NEGÓCIO</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'SOLD') {
              <div class="row" style="cursor: pointer;">
                <div class="col-9 ml-5">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">VENDIDO</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'BLOCKED') {
              <div class="row" style="cursor: pointer;">
                <div class="col-9 ml-5">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">BLOQUEADO</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'CONDITIONAL') {
              <div class="row" style="cursor: pointer;">
                <div class="col-9 ml-5">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">CONDICIONAL</div>
                </div>
              </div>
              }

              @if (vehicle().negotiationStatus === 'AVAILABLE_FOR_SALE') {
              <div class="row" style="cursor: pointer;">
                <div class="col-9 ml-5">
                  <div class="row label-text-status">status da negociação</div>
                  <div class="row label-status">DISPONÍVEL P/ VENDA</div>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>

        @if (vehicle().status === 'NEGOTIATION' && hasPermissionConfirmPurchase()) {
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                  loading: loading,
                  disabled: loading,
                  class:'btn btn-primary btn-rounded btn-block',
                  label:'CONFIRMAR COMPRA',
                  click: onClickConfirmBought
                }">
          </ng-container>
        </div>
        }
        @if (hasPermissionEditPrice()) {
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                  loading: loading,
                  disabled: loading,
                  class:'btn btn-outline-primary btn-rounded btn-block',
                  label:'EDITAR PREÇO',
                  click: toggleShowBoxEditPrice
                }">
          </ng-container>
        </div>
        }
        @if (vehicle().status === 'NEGOTIATION' && hasPermissionArchiveNegotiation()) {
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                  loading: loading,
                  disabled: loading,
                  class:'btn btn-outline-primary btn-rounded btn-block',
                  label:'ARQUIVAR NEGOCIAÇÃO',
                  click: onClickArchive
                }">
          </ng-container>
        </div>
        }

        @if (vehicle().status === 'AWAITING_ENTRY' && hasPermissionConfirmPurchase()) {
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                  loading: loading,
                  disabled: loading,
                  class:'btn btn-primary btn-rounded btn-block',
                  label:'CONFIRMAR RECEBIMENTO',
                  click: onClickConfirmReceipt
                }">
          </ng-container>
        </div>
        }
        @if (vehicle().status === 'AWAITING_ENTRY' && hasPermissionReturnToNegotiation()) {
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                  loading: loading,
                  disabled: loading,
                  class:'btn btn-outline-primary btn-rounded btn-block',
                  label:'VOLTAR PARA NEGOCIAÇÃO',
                  click: onClickReturnToNegotiation
                }">
          </ng-container>
        </div>
        }
      </div>
      }
      <!--/ BOX-INFO -->

      <!-- BOX EDIT PRICE -->
      @if (showBoxEditPrice && vehicle().status === 'NEGOTIATION') {
      <div class="row box-input">
        <div class="col-md-12 value">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h3>
              <i class="app-icon-tag"></i>EDITAR PREÇO
            </h3>
            @if (fipePrice > 0) {
            <app-fipe-comparison-badge
              variant="tag"
              accentColor="#16B097"
              [price]="price.value"
              [fipePrice]="fipePrice"
              [displayMode]="userInfo?.fipeComparisonMode"
              digits="1.1-1"
            />
            }
          </div>
          <mat-form-field style="margin-top: -18px;">
            <span matPrefix class="currency-symbol">R$&nbsp;</span>
            <input [formControl]="price" matInput currencyMask
              [options]="{ prefix: '', thousands: '.', precision: 2, allowNegative: false }" type="tel"
              (click)="$event.stopPropagation();" (blur)="onPriceBlur()">
            <mat-icon matSuffix style="font-size: 24px; color: var(--menu-item-color);">mode_edit</mat-icon>
          </mat-form-field>
          @if (fipeOutOfRangeAlertVisible) {
          <div class="pricing-fipe-hint" role="status">
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            Valor fora da faixa esperada da FIPE. Confirme se está correto.
          </div>
          }
          @if (showFactoryBonus) {
          <div class="small-form-field">
            <label>Bônus de fábrica</label>
            <mat-form-field>
              <span matPrefix class="currency-symbol">R$&nbsp;</span>
              <input [formControl]="factoryBonus" matInput currencyMask [options]="{
                      prefix: '',
                      thousands: '.',
                      precision: 0,
                      allowNegative: false
                    }" type="tel" (click)="$event.stopPropagation()" [disabled]="canEditFactoryBonus" />
            </mat-form-field>
          </div>
          <div class="small-form-field">
            <label>Intervenção</label>
            <mat-form-field>
              <span matPrefix class="currency-symbol">R$&nbsp;</span>
              <input [formControl]="interventionPrice" matInput currencyMask [options]="{
                      prefix: '',
                      thousands: '.',
                      precision: 0,
                      allowNegative: false
                    }" type="tel" (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
          }
          <div class="small-form-field">
            <label>Preço mínimo para venda</label>
            <mat-form-field>
              <span matPrefix class="currency-symbol">R$&nbsp;</span>
              <input [formControl]="minSellPrice" matInput currencyMask [options]="{
                    prefix: '',
                    thousands: '.',
                    precision: 0,
                    allowNegative: false
                  }" type="tel" (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
          <div class="small-form-field mb-4">
            <label>Preço para anúncio</label>
            <mat-form-field>
              <span matPrefix class="currency-symbol">R$&nbsp;</span>
              <input [formControl]="listPrice" matInput currencyMask [options]="{
                    prefix: '',
                    thousands: '.',
                    precision: 0,
                    allowNegative: false
                  }" type="tel" (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
          <div class="row" style="margin-top: -25px;">
            <div class="col-md-12">
              <textarea [formControl]="commentClosePricing" placeholder="COMENTÁRIOS" class="form-control" rows="10"
                style="resize: none;"></textarea>
            </div>
            <div class="col-md-12 my-4">
              <mat-checkbox class="checkbox-responsability" [formControl]="checkboxResposability">Eu assumo a
                responsabilidade na
                alteração do preço de captação.</mat-checkbox>
            </div>
            @if (vehicle().status === 'NEGOTIATION') {
            <div class="col-md-12" style="margin-top: -15px">
              <mat-checkbox class="checkbox-responsability" [formControl]="checkboxInterventionPrice">
                Essa edição de preço é mediante uma intervenção.
              </mat-checkbox>
            </div>
            }
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                loading: loadingUpdatePricing,
                disabled: !canSaveUpdatedPrice(),
                class:'btn btn-primary btn-rounded btn-block',
                label:'SALVAR PREÇO',
                click: onClickUpdatePrice
              }">
          </ng-container>
        </div>
        <div class="col-md-12 mt-3">
          <ng-container *ngTemplateOutlet="btnLoading; context:{
                loading: false,
                disabled: loading,
                class:'btn btn-outline-primary btn-rounded btn-block',
                label:'CANCELAR',
                click: toggleShowBoxEditPrice
              }">
          </ng-container>
        </div>
      </div>
      }
      <!--/ BOX EDIT PRICE -->
      } @else {
      <div class="row box-input">
        <div class="col-md-12 value">
          <h3>
            <i class="app-icon-tag"></i>PREÇO PARA COMPRA
          </h3>
          <div class="col-md-12 mt-2">
            <span class="symbol">R$</span>
            <span class="value">{{vehicle().price | number: '1.2-2' }}</span>
          </div>
        </div>
      </div>
      }
    </div>

    <!--FOOTER-->
    @if (hasPermissionBackPricing()) {
    <div class="card-footer">
      @if (showGiveBack) {
      <div class="tooltip-lens" [style.display]="commentGiveBack.hasError('required') ? 'block' : 'none'">
        <div class="ballon">
          <div class="wrapper-content">
            <p class="text-danger">Informe o motivo da devolução para a precificação.</p>
          </div>
        </div>
      </div>
      <textarea [formControl]="commentGiveBack" autofocus placeholder="O QUE FALTOU NA PRECIFICAÇÃO?"
        class="form-control" rows="10" style="resize: none;"></textarea>
      <ng-container *ngTemplateOutlet="btnLoading; context:{
            loading: loadingReturnPricing,
            disabled: !commentGiveBack.valid,
            class:'btn btn-danger btn-rounded btn-block',
            label:'DEVOLVER PARA PRECIFICAÇÃO',
            click: onClickReturnPricing
          }">
      </ng-container>
      <button class="d-block cancel" (click)="onClickGiveBack()">CANCELAR</button>
      } @else {
      <div>NÃO CONCORDA COM A PRECIFICAÇÃO?</div>
      <button class="give-back" type="button" (click)="onClickGiveBack()"><u>Devolver para precificação</u></button>
      }
    </div>
    }
    <!--/ FOOTER-->
  </div>
</div>

<ng-template #btnLoading let-class="class" let-loading="loading" let-disabled="disabled" let-click="click"
  let-label="label">
  <button [class]="class" (click)="click()" [disabled]="disabled || loading" [ngClass]="{loading: loading}">
    @if (loading) {
    <div class="btn-spinner float-left"></div>
    }
    <span>
      {{label}}
    </span>
  </button>
</ng-template>